/**
 * footer.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/20 下午5:53
 */

import React from 'react';

const Footer = props => {
  const { className = '' } = props;
  return (
    <footer>
      <div className={`footer-main ${className}`}>
        <span className="footer-copyright">
          <span className="footer-copyright-icon">&copy;</span>
          1997-{new Date().getFullYear()} 网易公司版权所有
        </span>
        <a href="http://corp.163.com/">About NetEase</a>
        <div className="footer-link">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="//mp.163.com/media_static/html/about.html">
            关于网易号
          </a>
          <a target="_blank" rel="noopener noreferrer" href="//mp.163.com/agreement.html">
            用户协议
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://mp.163.com/college.html#/home">
            创作指南
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="//mp.163.com/college.html?wemediaId=W1686582682210028374#/guidence/hot/account">
            常见问题
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="//mp.163.com/customer.html#/details/feedback">
            联系我们
          </a>
          <a target="_blank" rel="noopener noreferrer" href="//mp.163.com/developer.html#/index">
            开发者平台
          </a>
          {/* <a target="_blank" rel="noopener noreferrer" href="http://www.bjjubao.org/index.htm">
            不良信息举报
          </a> */}
        </div>
      </div>
    </footer>
  );
};
export default Footer;
